<div class="share-block">
  {#if data && (data.shareProvider === 'IFRAME' || data.shareProvider === 'YOUTUBE')}
    <!-- <figure class='share-figure{data.src.match("matterport") ? " virtual_tour" : ""}'> -->
    <figure class="share-figure{data.src.match('rasp.yandex') ? ' hideOnTerminal' : ''}">
      <iframe
        src="{data.src}"
        frameborder="{data.frameborder}"
        style="{data.style}"
        width="100%"
        allowfullscreen
       ></iframe>
    </figure>
  {/if}
</div>

<style>
  .share-block {
    margin-bottom: 2.5rem;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .share-figure {
    position: relative;
    padding-bottom: 56.5%;
    margin-bottom: 12px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>